import { BarEditPageSaveReason } from './bar-edit-page-save-reason.enum';

/** Arguments object for edit page save. */
export class BarEditPageSaveArgs<TModel = unknown> {
    /** The model to save with the modifications applied. */
    model: TModel;
    /** Defines the trigger that caused the save. */
    reason: BarEditPageSaveReason;
    /** Whether to prevent the load after a successfull save. */
    preventLoad = false;
    /** Extra data given in through custom save operation. */
    data: any;
}
